/* eslint-disable node/no-unsupported-features/es-syntax */
import { KIT_ROUTE_NAMES } from "@/shared";
export const KIT_ROUTES = [
    {
        name: KIT_ROUTE_NAMES.LIST,
        path: "/kit",
        meta: {
            title: "words.kits",
        },
        component: () => import("../ui/KitList.vue"),
    },
    {
        name: KIT_ROUTE_NAMES.CARD,
        path: "/kit/:id",
        meta: {
            title: "words.kit_card",
        },
        component: () => import("../ui/KitCard.vue"),
        props: true,
    },
    {
        name: KIT_ROUTE_NAMES.ADD,
        path: "/kit/add",
        meta: {
            title: "words.add_kit",
        },
        component: () => import("../ui/KitEdit.vue"),
    },
    {
        name: KIT_ROUTE_NAMES.EDIT,
        path: "/kit/edit/:id",
        meta: {
            title: "words.edit_kit",
        },
        component: () => import("../ui/KitEdit.vue"),
        props: true,
    },
];
